import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import "antd/dist/antd.less";
import { ThemeProvider } from "styled-components";
import { Provider } from "react-redux";
import { Layout } from "antd";
import store from "./store";
/* CUSTOM COMPONENTS */
import Header from "./component/Header/Header";
import SubHeader from "./component/SubHeader/SubHeader";
import PageBody from "./component/PageBody/PageBody";
import Sidebar from "./component/Sidebar/Sidebar";
import PageContainer from "./component/PageContainer/PageContainer";
import PrivateRoute from "./component/PrivateRoute";
import WellKnown from "./page/WellKnown/Wellknown";
import HeaderContext from "./context/HeaderContext";
// others
import theme from "./theme";

//Pages
import NotFound from "./page/NotFound/NotFound";
import AppointmentList from "./page/Appointments/AppointmentList/AppointmentList";
import Home from "./page/Home/Home";
import Schedule from "./page/Schedule/Schedule";
import PatientEditForm from "./page/PatientEditForm/PatientEditForm";
import CouponList from "./page/CouponEngine/CouponList/CouponList";
import CouponSave from "./page/CouponEngine/CouponSave/CouponSave";
import ProfileSetting from "./page/ProfileSetting/ProfileSetting";
import BookAppointment from "./page/BookAppointment/BookAppointment";
import Login from "./page/Login/Login";
import ResetPassword from "./page/ResetPassword/ResetPassword";
import PatientIntakeForm from "./page/PatientIntakeForm/PatientIntakeForm";
import AppointmentMeeting from "./page/Appointments/AppointmentMeeting/AppointmentMeeting";
import PatientList from "./page/Patient/PatientList/PatientList";
import ConsultationView from "./page/Patient/ConsultationView/ConsultationView";
import EmergencyDtrfSave from "./page/EmergencyDtrf/EmergencyDtrfSave/EmergencyDtrfSave";
import EmergencyDtrfDashboard from "./page/EmergencyDtrf/EmergencyDtrfDashboard/EmergencyDtrfDashboard";
import ContentRepoList from "./page/ContentRepo/ContentRepoList/ContentRepoList";
import ArticleList from "./page/Articles/ArticleList/ArticleList";
import ArticleView from "./page/Articles/ArticleView/ArticleView";
import SignUp from "./page/SignUp/SignUp";
import ForgotPassword from "./page/ForgotPassword/ForgotPassword";
import PrivateActivateRoute from "./component/PrivateActivateRoute";
import ReportList from "./page/Report/ReportList/ReportList";
import TestBookList from "./page/TestBook/TestBookList/TestBookList";
import BookmarkedArticles from "./page/BookmarkedArticles/BookmarkedArticles";
import Testimonial from "./page/Testimonial/Testimonial";
import QuickSupport from "./page/QuickSupport/QuickSupport";
import Dtrf_form from "./component/DtrfForm/DtrfForm";
import TestEmergencyDtrf from "./page/EmergencyDtrf/testEmergencyDtrf";
import DoctorDtrfDashboard from "./page/DoctorDtrfDashboard/Dashboard";
import ViewDtrfForm from "./page/DoctorDtrfDashboard/ViewDtrfForm";
import DtrfMobileForm from "./page/Dtrf/DtrfMobileForm";
import GuestRequestForm from "./page/GuestRequest/GuestRequestForm";
import Signup from "./page/Sign-Up/Signup";

const App = () => {
  // Variables
  const [collapsed, setCollapsed] = useState(false);
  const [title, setTitle] = useState("");

  const data = {
    title: title,
    setTitle: setTitle
  };

  // Functions
  const toggle = (data) => {
    setCollapsed(data);
  };

  return (
    <Provider store={store}>
      <HeaderContext.Provider value={data}>
        <ThemeProvider theme={theme}>
          <Router>
            <Switch>
              <Route exact path="/.well-known" component={WellKnown} />
              <Route path={["/dtrf-form/mobile"]} exact>
                <Route
                  exact
                  path="/dtrf-form/mobile"
                  component={DtrfMobileForm}
                />
              </Route>
              {/* With Auth and Doctor status is Pending */}
              <Route
                path={[
                  "/",
                  "/article",
                  "/article-read",
                  ,
                  "/article-watch",
                  "/article-listen",
                  "/article-detail/:slug",
                ]}
                exact
              >
                <Layout hasSider>
                  <Sidebar
                    collapsed={collapsed}
                    toggle={(data) => toggle(data)}
                  />
                  <Layout
                    style={{ marginLeft: collapsed ? 0 : 280 }}
                    className="p-0"
                  >
                    <Header
                      collapsed={collapsed}
                      toggle={(data) => toggle(data)}
                      className="site-layout-sub-header-background"
                      style={{ position: "fixed", zIndex: 1, width: "100%" }}
                    />
                    <PageBody>
                      <PageContainer>
                        <Switch>
                          <PrivateRoute exact path="/" component={Home} />
                          <PrivateRoute
                            exact
                            path="/article"
                            component={ContentRepoList}
                          />
                          <PrivateRoute
                            exact
                            path="/article-read"
                            component={ArticleList}
                          />
                          <PrivateRoute
                            exact
                            path="/article-watch"
                            component={ArticleList}
                          />
                          <PrivateRoute
                            exact
                            path="/article-listen"
                            component={ArticleList}
                          />
                          <PrivateRoute
                            exact
                            path="/article-detail/:slug"
                            component={ArticleView}
                          />
                        </Switch>
                      </PageContainer>
                    </PageBody>
                  </Layout>
                </Layout>
              </Route>

              {/* With Auth and Doctor status is Activate */}

              <Route
                path={[
                  "/appointment",
                  "/consultationview/:id",
                  "/schedule",
                  "/patient",
                  "/patient/edit/:id",
                  "/coupon/list",
                  "/coupon/save",
                  "/coupon/save/:id",
                  "/ProfileSetting",
                  "/appointment/save",
                  "/ProfileSetting/ResetPassword",
                  "/appointment/meeting/:id",
                  "/emeregency-dtrf",
                  "/emeregency-dtrf/dashboard",
                  "/reports",
                  "/test-book",
                  "/BookmarkedArticles",
                  "/Testimonial",
                  "/QuickSupport",
                  "/dtrfs",
                  "/dtrf/:id",
                  "/dtrf-form",
                  "/dtrf-form/mobile",
                  "/guest-request",
                ]}
                exact
              >
                <Layout hasSider>
                  <Sidebar
                    collapsed={collapsed}
                    toggle={(data) => toggle(data)}
                  />
                  <Layout
                    className="common-main-container"
                    style={{ marginLeft: collapsed ? 0 : 280 }}
                  >
                    <Header
                      collapsed={collapsed}
                      toggle={(data) => toggle(data)}
                      className="site-layout-sub-header-background"
                      style={{ position: "fixed", zIndex: 1, width: "100%" }}
                    />
                    <PageBody>
                      <PageContainer>
                        <Switch>
                          <PrivateActivateRoute
                            exact
                            path="/schedule"
                            component={Schedule}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/patient"
                            component={PatientList}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/patient/edit/:id"
                            component={PatientEditForm}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/consultationview/:id"
                            component={ConsultationView}
                          />
                          {/* <PrivateActivateRoute exact path="/coupon/list" component={CouponList} />
                        <PrivateActivateRoute exact path="/coupon/save" component={CouponSave} />
                      <PrivateActivateRoute exact path="/coupon/save/:id" component={CouponSave} /> */}
                          <PrivateActivateRoute
                            exact
                            path="/ProfileSetting"
                            component={ProfileSetting}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/appointment/save"
                            component={BookAppointment}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/appointment"
                            component={AppointmentList}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/appointment/meeting/:id"
                            component={AppointmentMeeting}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/ProfileSetting/ResetPassword"
                            component={ResetPassword}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/emeregency-dtrf"
                            component={TestEmergencyDtrf}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/emeregency-dtrf/dashboard"
                            component={EmergencyDtrfDashboard}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/reports"
                            component={ReportList}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/test-book"
                            component={TestBookList}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/BookmarkedArticles"
                            component={BookmarkedArticles}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/Testimonial"
                            component={Testimonial}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/QuickSupport"
                            component={QuickSupport}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/dtrf-form"
                            component={Dtrf_form}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/dtrf/:id"
                            component={ViewDtrfForm}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/dtrfs"
                            component={DoctorDtrfDashboard}
                          />
                          <PrivateActivateRoute
                            exact
                            path="/guest-request"
                            component={GuestRequestForm}
                          />
                        </Switch>
                      </PageContainer>
                    </PageBody>
                  </Layout>
                </Layout>
              </Route>

              {/* Without Auth */}
              <Route
                path={[
                  "/login",
                  "/sign-up",
                  "/forgot-password",
                  "/dtrf-form/mobile",
                ]}
                exact
              >
                <Switch>
                  <Route exact path="/login" component={Login} />
                  {/* <Route exact path="/sign-up" component={SignUp} /> */}
                  <Route exact path="/sign-up" component={Signup} />

                  <Route
                    exact
                    path="/forgot-password"
                    component={ForgotPassword}
                  />
                  <Route
                    exact
                    path="/forgot-password"
                    component={ForgotPassword}
                  />
                </Switch>
              </Route>

              {/* Without Auth */}
              <Route path={["/patient-intake-form/:book_appointment_id"]} exact>
                <Layout>
                  <Header />
                  <Layout>
                    <PageBody>
                      <PageContainer>
                        <Switch>
                          <Route
                            exact
                            path="/patient-intake-form/:book_appointment_id"
                            component={PatientIntakeForm}
                          />
                        </Switch>
                      </PageContainer>
                    </PageBody>
                  </Layout>
                </Layout>
              </Route>
            </Switch>
          </Router>
        </ThemeProvider>
      </HeaderContext.Provider>
    </Provider>
  );
};

export default App;
